// Create a new Class that inherits from this class

import PubSub from './events/PubSub';

export default class LiveChatBase {
    // static include = _include;
    constructor(prop) {
        this.include = _include;
        this.prop = prop;
        this.pubSub = new PubSub();
    }

    publish(e) {
        this.pubSub.publish.call(this, e);
    }

    subscribe(e, h) {
        this.pubSub.subscribe.call(this, e, h);
    }

    eventSubscriptions(evt) {
        return this.pubSub.eventSubscriptions.call(this, evt);
    }

    clearAllSubscriptions() {
        return this.pubSub.clearSubscriptions.call(this);
    }

    execute(funcName) {
        return this[funcName] && this[funcName].apply(this, [].slice.call(arguments, 1));
    }

    log(msg) {
        if (window.console && ApexChat.trace) {
            console.log(`>>${msg}`);
        }
    }
}

const extend = function (dest, src) {
    for (let prop in src) {
        dest[prop] = src[prop];
    }
    return dest;
};
const _include = function (o) {
    extend(this, o);
};
